import styled, { css } from 'styled-components';

import PolyLoader from '@polyai/ui/components/atoms/PolyLoader';
import Text from '@polyai/ui/components/atoms/Text';
import breakpoints from '@polyai/ui/styles/config/breakpoints';
import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';

const Container = styled.div<{
  $sidebarOffset: number;
  $useMediaQuery: boolean;
}>`
  pointer-events: none;

  position: fixed;
  z-index: 20;
  inset: ${sizes.headerHeight}px 0 0 ${({ $sidebarOffset }) => $sidebarOffset}px;

  display: flex;
  flex-direction: column;
  gap: ${themeSpacing.sm1};
  align-items: center;
  justify-content: center;

  background-color: ${themeColors.backgroundPage};

  /* Avoid layout shift from JS breakpoint timing */
  ${({ $useMediaQuery }) =>
    $useMediaQuery &&
    css`
      inset: ${sizes.headerHeight}px 0 0 0;

      @media (min-width: ${breakpoints.sm}px) {
        inset: ${sizes.headerHeight}px 0 0 ${sizes.mainNavWidth}px;
      }
    `}
`;

const LoaderWrapper = styled.div`
  width: ${sizes.loadingAnimation}px;
  height: ${sizes.loadingAnimation}px;
`;

interface ContentLoaderAreaProps {
  withSidebarOffset?: boolean;
  /**
   * Use CSS media query for sidebar offset instead of JS prop.
   * Prevents layout shift from useBreakpoint timing during initial load.
   */
  useMediaQueryForOffset?: boolean;
}

const ContentLoaderArea = ({
  withSidebarOffset = false,
  useMediaQueryForOffset = false,
}: ContentLoaderAreaProps) => {
  const sidebarOffset = withSidebarOffset ? sizes.mainNavWidth : 0;

  return (
    <Container
      $sidebarOffset={useMediaQueryForOffset ? 0 : sidebarOffset}
      $useMediaQuery={useMediaQueryForOffset}
      data-test-id="content-loader-area"
    >
      <LoaderWrapper>
        <PolyLoader />
      </LoaderWrapper>
      <Text color="textSecondary" variant="bodySemibold">
        Loading
      </Text>
    </Container>
  );
};

export default ContentLoaderArea;
